import type { OrgChartOptionCompare, OrgChartViewOptions } from "../types";

const datesEnableShowChanges = (viewOptions: OrgChartViewOptions) =>
  Boolean(viewOptions.fromDate?.isValid?.() && viewOptions.toDate?.isValid?.());

const overlayKey = (optionId: string | null | undefined) =>
  optionId || "current";

export const hasOptionCompare = (viewOptions: OrgChartViewOptions) =>
  Object.prototype.hasOwnProperty.call(viewOptions, "compareFromOptionId") ||
  Object.prototype.hasOwnProperty.call(viewOptions, "compareToOptionId");

/**
 * Option compare diffs two live overlays (or an overlay and live trunk), so
 * it has no from/to dates and both pits are read as of today.
 */
export const isOptionCompareActive = (viewOptions: OrgChartViewOptions = {}) =>
  Boolean(viewOptions.showChanges) && hasOptionCompare(viewOptions);

/** Isolated from date-compare period keys. Empty when option compare is off. */
export const getOptionCompareResetKey = (
  viewOptions: OrgChartViewOptions = {}
): string => {
  if (!hasOptionCompare(viewOptions)) {
    return "";
  }
  return `${overlayKey(viewOptions.compareFromOptionId)}|${overlayKey(
    viewOptions.compareToOptionId
  )}`;
};

/**
 * Canvas owns option-vs-option compare. Team-tab date compare is unchanged
 * when optionCompare is omitted (undefined).
 */
export const applyOptionCompareToViewOptions = (
  viewOptions: OrgChartViewOptions,
  optionCompare: OrgChartOptionCompare | null
): OrgChartViewOptions => {
  if (!optionCompare) {
    const next = { ...viewOptions };
    delete next.compareFromOptionId;
    delete next.compareToOptionId;
    return {
      ...next,
      showChanges: datesEnableShowChanges(next),
    };
  }
  return {
    ...viewOptions,
    showChanges: true,
    fromDate: null,
    toDate: null,
    compareFromOptionId: optionCompare.fromOptionId,
    compareToOptionId: optionCompare.toOptionId,
  };
};
